import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ContentSection } from './components/ContentSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { SocialProofSection } from './components/SocialProofSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cerebro-dark font-sans selection:bg-cerebro-blue/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <ContentSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <SocialProofSection data-id="element-9" />
        <CtaSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}